import { render, staticRenderFns } from "./SystemQuiz.vue?vue&type=template&id=432fe636&scoped=true&"
import script from "./SystemQuiz.vue?vue&type=script&lang=js&"
export * from "./SystemQuiz.vue?vue&type=script&lang=js&"
import style0 from "./SystemQuiz.vue?vue&type=style&index=0&id=432fe636&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432fe636",
  null
  
)

/* custom blocks */
import block0 from "./SystemQuiz.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports